import { useMutation, useQueryClient } from '@tanstack/react-query'

import { segmentsApi } from '@/api/segments/segmentsApi'
import { segmentsQueries } from '@/api/segments/segmentsQueries'
import type { SegmentStatusType } from '@/types'

export const useChangeSegmentStatusMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: SegmentStatusType }) =>
      segmentsApi.changeStatus(id, status),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: segmentsQueries.all() }),
  })
}
